import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWalletFill = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1.125em",
	height: "1.125em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M7 5L19 1C19.3333 1 20 1.2 20 2V5H7Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5 6C4 6 2 6.6 2 9V19C2 20 2.6 22 5 22H19C20 22 22 21.4 22 19V9C22 8 21.4 6 19 6H5ZM16 15C16.5523 15 17 14.5523 17 14C17 13.4477 16.5523 13 16 13C15.4477 13 15 13.4477 15 14C15 14.5523 15.4477 15 16 15Z",
		fill: "currentColor"
	})]
});
export default SvgWalletFill;
